import React, { useState } from 'react';
import {Col, InputGroup, InputGroupAddon, InputGroupText, Input, FormGroup,
   Button, Label, Form, FormFeedback, Alert } from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { UPDATE_PASSWORD, SEND_OTP } from '../../utils/APIEndpoints';
import { authHeader } from '../../utils/functions/CoreFunctions';
import API from '../../redux/actions/API';
import { getAlertToast, getAlert } from '../../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';
import { SIGNIN_PATH } from '../../utils/AppRoutes';
import { useHistory } from 'react-router-dom';
import CustomLoader from '../common/CustomLoader';
import { SIX_DIGIT_OTP_CODE_REGEX } from '../../utils/constants/ValidationRegexs';

const validationSchema = Yup.object({
  otpValue: Yup.string().required('OTP is required').matches(SIX_DIGIT_OTP_CODE_REGEX,'Give valid six digits OTP code'),
  password: Yup.string().required('Password is required'),
  confirmPassword: Yup.string().required('Confirm password is required')
  .test('passwords-match', 'Password mismatch', function(value) {
    return this.parent.password === value;
  }),
});
 
const UpdatePassword = (props) => {

    const history = useHistory();

    const [loading,setLoading] = useState(false);
    const [otpLoading,setOtpLoading] = useState(false);
    const [isPasswordType,setPasswordInputType] = useState(true);
    const [isConfPasswordType,setConfPasswordInputType] = useState(true);


    const togglePasswordType = () => {
      setPasswordInputType(!isPasswordType);
    }

    const toggleConfPasswordType = () => {
      setConfPasswordInputType(!isConfPasswordType);
    }

    const { handleSubmit, handleChange, values, errors,touched,setFieldTouched } = useFormik({
        initialValues: {
          email:props.email,
          otpValue: '',
          password: '',
          confirmPassword: ''
        },
        validationSchema,
        onSubmit(values) {
            updatePassword(values);  
        }
      });

      const getOTP = async () => {
        try{
          setOtpLoading(true);
          const options = {
              method : 'GET',
              url : SEND_OTP,
              headers : authHeader(),
              params : { email: props.email}
          };
          const response = await API(options);
          const {status,message} = response.data;
          if(status === 'Success')
          {
            Swal.fire(getAlertToast('success', 'OTP successfully sent to your email account')); 
          }
          }catch(error){
              if (error.response) {
              let { data } = error.response;
              Swal.fire(getAlertToast('error', data.message));
              }
          }finally{
              setOtpLoading(false);
          }
      }

    const updatePassword = async (values) => {
      try{
        setLoading(true); 
        const options = {
            method : 'PUT',
            url : UPDATE_PASSWORD,
            headers: authHeader(),
            data: values
        }; 
        const response = await API(options);
        const {status, message } = response.data;
        if(status === 'Success')
        {
          Swal.fire(getAlertToast('success', 'Password updated successfully')); 
          history.push(SIGNIN_PATH);  
        }else{
          Swal.fire(getAlertToast('error', message)); 
        }
        }catch(error){
            if (error.response) {
            let { data } = error.response;
            Swal.fire(getAlertToast('error', data.message)); 
            }
        }finally{
            setLoading(false);
        }
    }

    return (
        <Col xs='6' className='bg-white p-4 pt-5 pb-5'>
        <h5 className='mb-4'>Update Password</h5>
          <Alert color="success">
            {/* <h6 className="alert-heading">Success!</h6> */}
            <p>
              We sent OTP successfully to <b>{props.email}</b>
            </p>          
        </Alert>
        <Form onSubmit={handleSubmit}>
        <FormGroup>
        <Label for='exampleEmail'>OTP</Label>
        <InputGroup>
        <InputGroupAddon addonType='prepend'>
        <InputGroupText><i className='far fa-envelope'></i></InputGroupText>
        </InputGroupAddon>
        <Input name='otpValue' placeholder='Enter OTP'  
        invalid={(errors.otpValue && touched.otpValue) ? true : false} 
                      onChange={(event) => {
                          setFieldTouched('otpValue',true);
                          handleChange(event);
                      }}  
        values={values.otpValue}/>
         <FormFeedback>{(errors.otpValue && touched.otpValue) ? errors.otpValue : null}</FormFeedback>
        </InputGroup>
        </FormGroup>
        <FormGroup>
        <Label for='examplePassword'>Password</Label>
        <InputGroup>       
        <Input type={isPasswordType ? 'password' : 'text' } name='password' placeholder='Enter Password' 
         invalid={(errors.password && touched.password) ? true : false} 
         onChange={(event) => {
             setFieldTouched('password',true);
             handleChange(event);
         }} 
         values={values.password}/>
          <InputGroupAddon addonType="append">
            <InputGroupText onClick={togglePasswordType} style={{cursor:'pointer'}}>
              {isPasswordType ?
              <i className="fas fa-eye-slash"/> : <i className="fas fa-eye"/>
              }
            </InputGroupText>
          </InputGroupAddon>  
          <FormFeedback>{(errors.password && touched.password) ? errors.password : null}</FormFeedback>
        </InputGroup>  
      </FormGroup>
      <FormGroup>
        <Label for='examplePassword'>Confirm Password</Label>
        <InputGroup>      
        <Input type={isConfPasswordType ? 'password' : 'text' } name='confirmPassword' placeholder='Enter Confirm Password' 
         invalid={(errors.confirmPassword && touched.confirmPassword) ? true : false} 
         onChange={(event) => {
             setFieldTouched('confirmPassword',true);
             handleChange(event);
         }} 
          values={values.confirmPassword}/>
          <InputGroupAddon addonType="append">
            <InputGroupText onClick={toggleConfPasswordType} style={{cursor:'pointer'}}>
              {isConfPasswordType ?
              <i className="fas fa-eye-slash"/> : <i className="fas fa-eye"/>
              }
            </InputGroupText>
          </InputGroupAddon>
          <FormFeedback>{(errors.confirmPassword && touched.confirmPassword) ? errors.confirmPassword : null}</FormFeedback>
        </InputGroup>      
      </FormGroup>
        <div className='mt-5'>
        <Button color='primary' type='button' onClick={getOTP} disabled={otpLoading}>
        {otpLoading && <CustomLoader loading={otpLoading}/>}{' '}     Resend OTP  
              </Button>
        <Button className='f-r' color='primary' type='submit' disabled={loading}>
        {loading && <CustomLoader loading={loading}/>}{' '}
        Update</Button>
        </div>
        </Form>
        </Col>
    );
}

export default UpdatePassword;
